import {get, post} from "./axios";

const Get = (url, params) =>
  get({
    service: "",
    url: url,
    data: params,
    headers: {"Content-Type": "application/json; charset=UTF-8"}
  });

const GetMap = (url, params) =>
  get({
    service: "",
    url: url,
    data: params,
    headers: {"Content-Type": "application/json; charset=UTF-8","X-API-Key": "0a602df6ee48895b3fe1831a899478c7"}
  });

export const newsApi = {
  list: params => Get("/node/get_news_list", params), //新闻
  product: params => Get("/node/get_product_info", params), //产品
  solution: params => Get("/node/get_solution", params), //解决方案
  service: params => Get("/node/get_safe_service", params), //安全服务
  getMapData: params =>GetMap("/ics/ow/get_operation_data",params)
};
